module.exports = __webpack_public_path__ + "static/profil-386_optimized-ddbf125e189e91bb06982c24eafee2c0.jpg";